import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'KEY_UPDATE',
    smsDelete : 'KEY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        key: null,
        submitSuccess: false,
        keyLoading: false,
        keyError: false,

        category: null,
        categoryLoading: false,
        categoryError: false,

        template: null,
        templateLoading: false,
        templateError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_KEY(state, key) {
            state.key = key;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        KEY_LOADING (state, loading) {
            state.keyLoading = loading;
        },

        KEY_ERROR (state, hasError) {
            state.keyError = hasError;
        },

        SET_CATEGORY(state, category) {
            state.category = category;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, hasError) {
            state.categoryError = hasError;
        },

        SET_TEMPLATE(state, template) {
            state.template = template;
        },

        TEMPLATE_LOADING (state, loading) {
            state.templateLoading = loading;
        },

        TEMPLATE_ERROR (state, hasError) {
            state.templateError = hasError;
        }
    },

    actions: {
        // API Key
        async addAPIKey ({commit, dispatch}, payload) {
            commit('KEY_LOADING', true);
            commit('KEY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_key, {openai_api_key: payload.key}, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchKey')
                return response

            } catch (e) {
                commit('KEY_ERROR', true);
            } finally {
                commit('KEY_LOADING', false);
            }
        },

        async fetchAPIKey ({ commit }) {
            commit('KEY_LOADING', true);
            commit('KEY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_key, config);
                let response = result.data
                commit('SET_KEY', response.data);

            } catch(error) {
                commit('KEY_ERROR', true);
            } finally {
                commit('KEY_LOADING', false);
            }
        },

        // Prompt Category
        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_prompt_category, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchCategory ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.prompt_category_list, config);
                let response = result.data
                commit('SET_CATEGORY', response.data);

            } catch(error) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async updateCategory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_prompt_category + payload.id, payload.category, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async deleteCategory ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.prompt_category_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCategory')
            return response
        },

        // Prompt Template
        async addTemplate ({commit, dispatch}, payload) {
            commit('TEMPLATE_LOADING', true);
            commit('TEMPLATE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_prompt_template, payload, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTemplate')
                return response

            } catch (e) {
                commit('TEMPLATE_ERROR', true);
            } finally {
                commit('TEMPLATE_LOADING', false);
            }
        },

        async fetchTemplate ({ commit }) {
            commit('TEMPLATE_LOADING', true);
            commit('TEMPLATE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.prompt_template_list, config);
                let response = result.data
                commit('SET_TEMPLATE', response.data);

            } catch(error) {
                commit('TEMPLATE_ERROR', true);
            } finally {
                commit('TEMPLATE_LOADING', false);
            }
        },

        async updateTemplate ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_prompt_template + payload.id, payload.template, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchTemplate')
                return response

            } catch (e) {
                commit('TEMPLATE_ERROR', true);
            } finally {
                commit('TEMPLATE_LOADING', false);
            }
        },

        async deleteTemplate ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.prompt_template_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchTemplate')
            return response
        },

        async toggleActive ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.get(V1API.prompt_template_toggle + payload, config).then(result=>{
                let data = result.data
                return data
            });

            commit('SUBMIT_SUCCESS', true);
            dispatch ('fetchTemplate')
            return response
        }
    },

    getters: {}
}
